module.exports = __webpack_public_path__ + "static/media/figure-one-new.c37fa865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/figure-one-new.png
// module id = 534
// module chunks = 0